export default __webpack_public_path__ + "static/media/testi1.27ac8143.jpg";